<template>
    <ac-modal :title="'New Physician'" ref="modal">
        <template v-if="widgetReady">
            <!-- Basic Info --->
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Physician Profile Name</label>
                        <small><span class="redText">required </span></small>
                        <input type="text" class="form-control " placeholder="Name" v-model="vm.mainModel.name">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Phone Number</label>
                        <small><span class="redText">required </span></small>
                        <br>
                        <ac-phone-number v-model="vm.mainModel.phoneNumber"></ac-phone-number>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Designation </label>
                        <select class="form-control" v-model="vm.mainModel.doctor.physicianCore.designationId">
                            <option v-for="d in designations" :value="d.designationId">
                                {{ d.designation }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>NPI</label>
                        <small><span class="redText">required </span></small>
                        <input class="form-control" type="text" v-model="vm.mainModel.doctor.physicianCore.npi">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            Tax Identification Number
                        </label>
                        <ac-masked-text-box v-model="vm.mainModel.tin" :mask="'00-0000000'"></ac-masked-text-box>
                    </div>
                </div>
            </div>
            <!-- Basic Info End--->

            <div>
                <shared-settings :parent-entity-id="parentEntityId" :data-model="vm.mainModel" ref="settings">

                </shared-settings>
            </div>

            <!-- Admin User Option -->
            <div class="row">
                <div class="col-lg-7">
                    <p>Create physician admin:</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <template v-if="vm.createAdminUser">
                                <input type="checkbox"
                                       v-model="vm.createAdminUser"
                                       :disabled="!hasValue(parentEntityId)"
                                       checked="">
                            </template>
                            <template v-else>
                                <input type="checkbox"
                                       v-model="vm.createAdminUser"
                                       :disabled="!hasValue(parentEntityId)">
                            </template>
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <hr/>
            <!-- Admin User Option End -->

            <!-- Admin User Creation -->
            <div v-if="vm.createAdminUser">
                <generic-profile-info v-model="vm.contactInfo">

                </generic-profile-info>
            </div>
            <!-- Admin User Creation End-->
        </template>
        <template slot="buttons">
            <ac-button class="btn-sm btn-red" :action="cancel">CANCEL</ac-button>
            <ac-button class="btn-sm btn-green" :action="createPhysician">CREATE PHYSICIAN</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import SharedSettings from "./SharedSettings.vue";
    import GenericProfileInfo from "../../GenericProfileInfo.vue";
    import {api} from "../../../../global/framework/api.js";
    import {common} from "../../../../global/common.js";
    import {configTables} from "../../../../global/configTables.js";

    export default {
        name: "NewPhysicianModal",
        components: {GenericProfileInfo, SharedSettings},
        data() {
            return {
                parentEntityId: 0,
                widgetReady: false,
                designations: [],
                vm: {}
            }
        },
        methods: {
            async showModal(parentEntityId) {
                this.parentEntityId = parentEntityId;
                await this.init();
                this.$refs.modal.open();
            },
            async init() {
                let [template, designations] = await Promise.all([
                    api.getNoId('ProviderEntityCreation', `providerWizardTemplate/${common.ENTITY_TYPE.PHYSICIAN}`),
                    configTables.getProfessionalDesignations()
                ]);
                this.designations = designations;
                template.mainModel.doctor.physicianCore.designationId = this.designations[0].designationId;
                if (this.hasValue(this.parentEntityId)) {
                    let provider = await api.get('ProviderEntity', this.parentEntityId, 'GetProviderEntity');
                    template.mainModel.parentEntityId = this.parentEntityId;
                    template.mainModel.phoneNumber = provider.phoneNumber;
                }
                this.mapData('vm', template);
                this.widgetReady = true;
            },
            cancel() {
                this.$refs.modal.close();
            },
            async createPhysician() {
                let settings = this.$refs.settings.getSettings();
                let dataToSend = this.clone(this.vm);
                dataToSend.mainModel = {...dataToSend.mainModel, ...settings};
                let result = await api.post('ProviderEntityCreation', 'CreateProviderEntity', dataToSend);
                if (result) {
                    this.$store.dispatch('myProviders/LOAD_MY_PROVIDERS', this.parentEntityId);
                    this.$bus.$emit(this.$AcEvents.NEW_PROVIDER, dataToSend);
                    this.$refs.modal.close();
                }
            }
        }
    }
</script>

<style scoped>

</style>